import { render, staticRenderFns } from "./GenericTouchPointComponent.vue?vue&type=template&id=41a03595"
import script from "./GenericTouchPointComponent.vue?vue&type=script&lang=ts"
export * from "./GenericTouchPointComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports